import React, { Component } from "react";

export { ErrorFallback } from "./_components/ErrorFallback";

type ErrorBoundaryProps = {
  fallbackComponent: React.ComponentType;
  children: React.ReactNode;
};

type ErrorBoundaryState = { hasError: boolean };

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { children, fallbackComponent: FallbackComponent } = this.props;
    const { hasError } = this.state;

    if (!hasError) {
      return children;
    }

    return <FallbackComponent />;
  }
}

export default ErrorBoundary;
